import { render, staticRenderFns } from "./plsx.vue?vue&type=template&id=23b3a15e&scoped=true"
import script from "./plsx.vue?vue&type=script&lang=js"
export * from "./plsx.vue?vue&type=script&lang=js"
import style0 from "./plsx.vue?vue&type=style&index=0&id=23b3a15e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3a15e",
  null
  
)

export default component.exports